export default class VisualPickerController {
  /* @ngInject */
  constructor($log, ConfigurationService, DictionaryService) {
    this.$log = $log;
    this.authorable = ConfigurationService.getConfiguration();
    this.solutionDictionaryLookup = DictionaryService.solutionDictionaryLookup;
    this.parentsWithCheckedChildren = this.parentsWithCheckedChildren || {};
  }

  $onInit() {
    this.previousFormData = angular.copy(this.formData);
    this.setParentWithCheckedChild();
  }

  $onChanges(changes) {
    if (changes.parentSolution) {
      this.parentKey = changes.parentSolution.currentValue.key;
      this.parent = this.authorable.SolutionDictionary[this.parentKey];
    }
    if (changes.formSolutions) {
      this.$log.log('formsolution change');
    }
  }

  $doCheck() {
    if (!angular.equals(this.formData, this.previousFormData)) {
      // do a deep copy of the formData for future comparison
      this.previousFormData = angular.copy(this.formData);
      this.setParentWithCheckedChild();
    }
  }

  childSolutionsAsText() {
    return this.parentSolution.children.map(child => this.solutionDictionaryLookup(child.key, 'name')).join(', ');
  }

  setParentWithCheckedChild() {
    if (this.formData.solutions) { // if there are any solution solutions selected
      // create an array of all the checked solution solutions
      const selectedChildSolutions = Object.keys(this.formData.solutions);
      // create an array of all the children in the current parent
      const parentsChildren = this.parentSolution.children.map(child => child.key);
      // look for a match of any selected solution with any children
      this.parentHasCheckedChild =
        selectedChildSolutions.some(child => parentsChildren.indexOf(child) >= 0);
    } else {
      // runs only if there are no values in this.formSolutions
      // now we can clear out the parent state of any checked children
      this.parentHasCheckedChild = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/search-form/visual-picker/visualPicker.controller.js